import { auth } from "@/firebase";

export async function register(email, password) {
  const userCredential = await auth.createUserWithEmailAndPassword(
    email,
    password
  );

  return userCredential.user;
}

export async function login(email, password) {
  try {
    const userCredential = await auth.signInWithEmailAndPassword(email, password);
    const user = userCredential.user;

    const token = await user.getIdToken();
    
    return { user, token };

  } catch (error) {
    console.warn("Error en login service:", error.code); 
    
    return null; 
  }
}

export async function sendPasswordReset(email) {
  await auth.sendPasswordResetEmail(email);
  return { success: true };
}

export async function updateExistingPassword(newPassword) {
  const user = auth.currentUser;
  if (!user) throw new Error("No hay usuario autenticado");

  await user.updatePassword(newPassword);
  return { success: true };
}